import React, { useState, createContext, useContext } from 'react';

const LoadingContext = createContext([false, () => {}]);

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
    const loadingState = useState(false);

    return (
        <LoadingContext.Provider value={loadingState}>
            {children}
        </LoadingContext.Provider>
    );
};